export default __webpack_public_path__ + "6dd9c20de52ba65d0cde8a5175773404.png";